import { Scale, AlertTriangle, Eye, CheckCircle } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

export function DisputesTab({ disputes, handleUpdateDisputeStatus, openResolveDialog }) {
  return (
    <div className="bg-surface border border-[#262626] rounded-xl">
      <div className="p-4 border-b border-[#262626]">
        <h2 className="font-heading text-xl font-bold flex items-center gap-2"><Scale className="w-5 h-5 text-red-400" />Dispute Management</h2>
        <p className="text-sm text-[#A1A1AA]">Review and resolve customer disputes</p>
      </div>
      {disputes.length === 0 ? (
        <div className="text-center py-16"><Scale className="w-16 h-16 mx-auto mb-4 text-[#333]" /><h3 className="text-xl font-heading font-bold mb-2">No Disputes</h3><p className="text-[#A1A1AA]">All orders are running smoothly!</p></div>
      ) : (
        <div className="divide-y divide-[#262626]">
          {disputes.map((dispute) => (
            <div key={dispute.id} className="p-4" data-testid={`dispute-${dispute.id}`}>
              <div className="flex flex-col lg:flex-row lg:items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <Badge className={`border-0 ${dispute.status === 'open' ? 'bg-red-500/10 text-red-400' : dispute.status === 'under_review' ? 'bg-yellow-500/10 text-yellow-400' : dispute.status === 'resolved' ? 'bg-green-500/10 text-green-400' : 'bg-gray-500/10 text-gray-400'}`}>
                      {dispute.status === 'open' && <AlertTriangle className="w-3 h-3 mr-1" />}
                      {dispute.status.replace('_', ' ').toUpperCase()}
                    </Badge>
                    <span className="text-sm text-[#888]">#{dispute.id.slice(0, 8)}</span>
                  </div>
                  <h3 className="font-bold mb-1">{dispute.reason_label}</h3>
                  <p className="text-sm text-[#A1A1AA] mb-3">{dispute.description}</p>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm bg-[#1a1a1a] rounded-lg p-3">
                    <div><span className="text-[#666]">Raised By</span><p className="font-medium">{dispute.raised_by_name}</p><p className="text-xs text-[#888] capitalize">({dispute.raised_by_role})</p></div>
                    <div><span className="text-[#666]">Order</span><p className="font-medium">${dispute.order_details?.price?.toFixed(2)}</p><p className="text-xs text-[#888] capitalize">{dispute.order_details?.status}</p></div>
                    <div><span className="text-[#666]">Artist</span><p className="font-medium">{dispute.order_details?.artist_name}</p></div>
                    <div><span className="text-[#666]">Buyer</span><p className="font-medium">{dispute.order_details?.user_name}</p></div>
                  </div>
                  {dispute.resolution && (
                    <div className="mt-3 p-3 bg-green-500/10 rounded-lg border border-green-500/30">
                      <p className="text-sm font-medium text-green-400 mb-1">Resolution: {dispute.resolution.type.replace('_', ' ').toUpperCase()}{dispute.resolution.amount && ` - $${dispute.resolution.amount.toFixed(2)}`}</p>
                      <p className="text-xs text-[#A1A1AA]">{dispute.resolution.notes}</p>
                    </div>
                  )}
                </div>
                <div className="flex flex-wrap gap-2">
                  {dispute.status === 'open' && (
                    <Button onClick={() => handleUpdateDisputeStatus(dispute.id, 'under_review')} variant="outline" size="sm" className="border-yellow-500/50 text-yellow-400 hover:bg-yellow-500/10"><Eye className="w-4 h-4 mr-1" />Mark Under Review</Button>
                  )}
                  {['open', 'under_review'].includes(dispute.status) && (
                    <Button onClick={() => openResolveDialog(dispute)} size="sm" className="bg-lime text-black hover:bg-lime/90" data-testid={`resolve-dispute-${dispute.id}`}><CheckCircle className="w-4 h-4 mr-1" />Resolve</Button>
                  )}
                </div>
              </div>
              <p className="text-xs text-[#666] mt-3">
                Opened: {new Date(dispute.created_at).toLocaleString()}
                {dispute.resolved_at && ` | Resolved: ${new Date(dispute.resolved_at).toLocaleString()}`}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
